import {
    SET_CITIES, 
    SET_DISPOSITIONSUBCHOICECITIES
} from './CitiesType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_CITIES:
            return {
                ...state,
                citiesDropDownList: action.citiesDropDownList,
            };
            case SET_DISPOSITIONSUBCHOICECITIES:
                return {
                    ...state,
                    dispositionSubChoiceCitiesDropDownList: action.dispositionSubChoiceCitiesDropDownList,
                };
        default:
            return state;
    }
}

export {
    reducers
}